import React from 'react';
import * as Styled from './MButtonIcon.styles';
import { MButtonIconProps, MButtonIconState } from './MButtonIcon.types';
import { AIcon, AIconSize } from '../../atoms/AIcon';

export const MButtonIcon: React.FC<MButtonIconProps> = ({
  state = MButtonIconState.Default,
  aIcon,
  size = AIconSize.M,
  ...rest
}) => {
  return (
    <Styled.ButtonIcon state={state} {...rest}>
      <AIcon icon={aIcon.icon} size={size} />
    </Styled.ButtonIcon>
  );
};

export * from './MButtonIcon.types';
